<template> 
    <div class="group">
        <div class="title h_48">商品分组</div>
        <Card >
            <Button type="primary" class="addBtn" @click="addGroup">新建商品分组</Button>
          
        <Table border :columns="columns" :data="list">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
            <template slot-scope="{ row }" slot="image">
                <img class="group-image" :src="row.image" alt=""/>
            </template>
           <template slot-scope="{ row }" slot="display">
                <i-switch v-model="row.isDisplay" :true-value="1" :false-value="0" @on-change="changeDisplay(row)"/>
            </template>
            <template slot-scope="{row ,index }" slot="action">
                <Button type="text"  @click="updateGroupBtn(row,index)">编辑</Button> 
                <Button type="text" class="delBtn" @click="delGroup(row,index)">删除</Button>  
            </template>
        </Table>
        </Card>

        <Modal
            v-model="visible"
            :footer-hide="true"
            >
            <div class="modal-header">
                <Icon type="ios-arrow-back" />
                <span>我的图片</span>/
                <span>本地上传</span>
            </div>
            
            <Form :model="formItem" :rules="ruleValidate"  ref="formValidate"  :label-width="100" >
                <FormItem label="排序:" prop="sort">
                    <Input v-model="formItem.sort" placeholder="未排序" />
                </FormItem>
                <FormItem label="分组名称:" prop="name">
                    <Input v-model="formItem.name" placeholder="分组名称" />
                </FormItem>
                <FormItem label="上传图片:" prop="image">
                    <div class="image-view">
                        <img :src='image' alt='' class="tem-image">
                        <Upload 
                            :show-upload-list="false"  
                            :action="action"
                            :headers='{"Authorization":"Bearer "+token}'
                            :on-success="handleSuccess"
                            :on-error="handleError"
                        >
                            <div class="upload">
                                <Icon type="md-add" size="38"/>
                                <span> {{image==''?'上传图片':'重新上传'}}</span>
                            </div>
                        </Upload>
                    </div>
                    <span>* 推荐图片比例1:1</span>
                </FormItem>
                 <FormItem label="隐藏:">
                     <i-switch v-model="formItem.isDisplay" :true-value="1" :false-value="0" />
                </FormItem>
            </Form>
            <div class="modal-footer">
                  <Button @click="submit">确定</Button>
            </div>
        </Modal>
    </div>
</template> 
<script>
import { mapState } from 'vuex'
import axios from 'axios'
    export default {
        name:'goods',
        data () {
            return { 
                guid:0,         //用户guid
                groupGuid:0,
                token:'',
                action:'https://api.jiapuji.vip/gateway/attached/service/attached/upload',
                formItem: {
                    isDisplay:0,
                    sort:0,
                    name:'',
                    image:''
                },
                columns: [
                    {
                        title: '分组名称',
                        slot: 'name'
                    },
                    {
                        title: '图片',
                        key: 'image',
                        slot: 'image',
                        align:'center'
                    },
                    {
                        title: '商品数',
                        key: 'num'
                    },
                    {
                        title: '创建时间',
                        key: 'createTime'
                    },
                    {
                        title: '排序',
                        key: 'sort',
                        sortable: true
                    },
                    {
                        title: '隐藏',
                        key: 'isDisplay',
                        slot: 'display'
                    },
                    {
                        title: '操作',
                        key: 'address',
                        slot: 'action',
                    }
                ],
                image:"",   //临时image url
                list: [] ,
                visible:false,
                isEdit:true,    //判断编辑还是 添加 
                ruleValidate:{
                        name: [
                        { required: true, message: '分组名称不能为空',  }
                        ],
                        sort: [
                        { required: true, message: 'The name cannot be empty',}
                        ],
                        image: [
                        { required: true, message: '分组图片不能为空',  }
                        ],
                    }
                
            }
        },
        created(){
           this.getData()
            this.guid = this.$store.state.guid
            this.token = this.$store.state.token
            this.action ="https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=13&guid="+this.$store.state.guid
        },
        methods: {
            //获取全部分组商品
            getData(){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/get'
                }).then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.list = res.data.data
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            },
            //改变状态
            changeDisplay(row){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/update?route=/layout/goods/category/update',
                    method:'put',
                    data:{
                        guid: row.guid,
                        isDisplay:row.isDisplay
                    }
                }).then(res=>{
                    console.log(res)
                     if(res.status == 200 && res.data.code==1){
                        this.$Message.success(res.data.message);
                    }else{
                        this.$Message.error('网络异常');
                    }
                   
                })
            },
            //添加分组
            addGroup(){
                this.visible = true
                this.isEdit = false
                this.image = ''
                this.formItem={isDisplay:0,sort:0,name:'',image:''}
            },
            //编辑按钮
            updateGroupBtn(row){
                this.isEdit = true
                this.visible = true
                this.image = ''
                this.formItem={
                    isDisplay:row.isDisplay,
                    sort:row.sort,
                    name:row.name,
                    image: false
                }
                this.groupGuid = row.guid
                this.image = row.image
            },
            //上传成功
            handleSuccess(e){
                if(e.code ==1){
                    this.$Message.success('上传成功');
                    this.formItem.image = e.data.name
                    this.image = e.data.path
                }
            },
            //上传失败
            handleError(){
                his.$Message.error('上传失败，请稍后再试')
            },
            //确定
            submit(){
                this.$refs['formValidate'].validate((valid) => {
                    if (valid) {
                       if(!this.isEdit){
                            //添加商品
                            axios({
                                url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/add?route=/layout/goods/category/add',
                                method:'POST',
                                data:{
                                    guid:this.guid,
                                    ...this.formItem
                                }
                            }).then(res=>{
                                if(res.status == 200 && res.data.code==1){
                                    this.$Message.success('添加成功');
                                    this.getData()
                                    this.visible = false
                                }else{
                                    this.$Message.error('网络异常');
                                }
                            })
                        }else{
                            //修改
                            axios({
                                url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/update?route=/layout/goods/category/update',
                                method:'PUT',
                                data:{
                                    guid:this.groupGuid,
                                    ...this.formItem,
                                    image:this.formItem.image==false?null:this.formItem.image
                                }
                            }).then(res=>{
                                if(res.status == 200 && res.data.code==1){
                                    this.$Message.success('添加成功');
                                    this.getData()
                                    this.visible = false
                                }else{
                                    this.$Message.error('网络异常');
                                }
                            })
                        }
                    } else {
                        this.$Message.error('请完整输入');
                    }
                })
                
            },
            //删除分组
            delGroup(row,index){
                 this.$Modal.confirm({
                    title: '提示',
                    content: '是否删除当前商品分组，删除后无法恢复',
                    onOk:() =>{
                        axios({
                            url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/delete?route=/layout/goods/category/delete&guid='+row.guid,
                            method:'DELETE',
                        }).then(res=>{
                            if(res.status == 200 && res.data.code==1){
                                this.$Message.success('删除成功');
                                const temList = []
                                this.list.forEach((item,i)=>{
                                    if(i!=index){
                                        temList.push(item)
                                    }
                                })
                                console.log(temList)
                                this.list = temList
                            }else{
                                this.$Message.error('网络异常');
                            }
                        
                        })
                    },
                    onCancel:()=>{
                        this.$Message.success('已取消')
                    }
                });
            }




        },
      
        
    }
</script>  
<style scoped>
    .group{
        padding: 20px;
    }
    .title{
        color: #333;
    }
    .title::before{
        content: '\258D';
        color: #1abc9c;
        font-weight: 900;
        margin-right: 10px;
    }
    .addBtn{
        margin-bottom: 20px;
    }
    .group-image{
        width: 70px;
        height: 70px;
        margin: 20;
        margin: 10px;
    }
    .modal-header{
        color:'#2d8cf0';
        padding-bottom:5px ;
        margin-bottom: 20px;
        border-bottom: 1px solid #CCCCCC;
    }
    .modal-footer{
        text-align: center;
        background-color: white;
    }
    .tem-image{
        width: 110px;
        height: 110px;
        object-fit: contain;
    }
    .delBtn{
        color:red;
    }
    .upload{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 110px;
        height: 110px;
        border: 1px dashed #ccc;
        margin-left: 20px;
     }
     .upload span{
         text-align: center;
     }
     .image-view{
         display: flex;
     }
</style>